import { Dialog, Button } from '@teachstonellc/component-library';

interface InstructionsModalProps {
  /**Title for the modal */
  title: string;

  /**Content message for the modal */
  message: React.ReactNode;

  /**Text for the button that dismisses the modal */
  confirmButton: string;

  /**Function called when the modal is dismissed */
  onClose: () => void;

  /**true when modal is open */
  isOpen: boolean;
}

function InstructionsModal({
  title,
  message,
  confirmButton,
  onClose,
  isOpen
}: InstructionsModalProps) {
  return (
    <Dialog
      open={isOpen}
      onOpenChange={open => !open && onClose()}
      title={title}
      titleClassName="text-center pb-4 pt-4"
      contentClassName="max-w-[680px] !rounded-[17px] !px-14 !pt-5"
      overlayClassName="!bg-[rgba(0,0,0,0.63)]"
      closeButton={
        <div className="w-full pb-4 px-4">
          <Button variant="primary" shape="rounded" fullWidth>
            {confirmButton}
          </Button>
        </div>
      }
    >
      {message}
    </Dialog>
  );
}

export default InstructionsModal;
